<template>
  <div
    v-if="staff"
    class="d-flex flex-row align-center pa-1"
    :key="staff.id"
    @click="$emit('change', staff)"
  >
    <v-avatar class="mr-2" size="36">
      <v-img :src="avatar"></v-img>
    </v-avatar>
    <div>
      <router-link :to="getLink">
        <div style="white-space: nowrap !important;">{{ staff.name }}</div>
      </router-link>
    </div>
  </div>
  <div v-else class="d-flex flex-row align-center pa-1">
    <v-avatar class="mr-2" size="36">
      <v-img :src="avatar"></v-img>
    </v-avatar>
    <div>Không có</div>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  props: {
    staff: Object,
    prepend: Object,
    append: Object,
    attendance: Object,
    link: Boolean,
    isStudent: { type: Boolean, default: false },
    isTeacher: { type: Boolean, default: false }
  },
  computed: {
    avatar() {
      return _.get(this.staff, 'avatar.url', '/default-avatar.png')
    },
    getLink() {
      if (this.isStudent) return '/student/' + this.staff.id
      if (this.isTeacher) return '/teacher/' + this.staff.id
      return '/staffs'
    }
  }
}
</script>

<style scoped></style>
